if (!customElements.get('bandelle-product-rail')) {
 customElements.define('bandelle-product-rail', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort = new AbortController();
   const start = () => { if (this.isConnected && !this.abort.signal.aborted) this.initialize(); };
   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true,signal:this.abort.signal});
   else start();
  }
  initialize() {
   const track=this.querySelector('.bl-products__track'), dots=this.querySelector('.bl-products__dots');
   if(!track || !dots) return;
   const cards=Array.from(track.querySelectorAll('.bl-product')), options={signal:this.abort.signal};
   const previous=this.querySelector('[data-direction="-1"]'), next=this.querySelector('[data-direction="1"]');
   if(!cards.length){previous.hidden=true;next.hidden=true;return;}
   const step=()=>cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:cards[0].getBoundingClientRect().width;
   const visible=()=>Math.max(1,Math.round(track.clientWidth/step()));
   let groups=[];
   const go=index=>track.scrollTo({left:Math.min(index*step(),track.scrollWidth-track.clientWidth),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
   const update=()=>{
    const max=track.scrollWidth-track.clientWidth, current=Math.round(track.scrollLeft/step());
    previous.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=max-2;
    let selected=0;groups.forEach((group,i)=>{if(current>=group)selected=i;});
    if(track.scrollLeft>=max-2)selected=groups.length-1;
    Array.from(dots.children).forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===selected)));
   };
   const rebuild=()=>{
    dots.replaceChildren();groups=[];
    const count=visible();
    for(let index=0;index<cards.length;index+=count){
     const target=Math.min(index,Math.max(0,cards.length-count));
     if(groups.includes(target))continue;
     groups.push(target);const dot=document.createElement('button');dot.type='button';dot.setAttribute('aria-label','Show products '+(target+1)+' to '+Math.min(target+count,cards.length));dot.setAttribute('aria-controls',track.id);
     dot.addEventListener('click',()=>go(target),options);dots.append(dot);
    }
    update();
   };
   previous.addEventListener('click',()=>go(Math.max(0,Math.round(track.scrollLeft/step())-visible())),options);
   next.addEventListener('click',()=>go(Math.round(track.scrollLeft/step())+visible()),options);
   track.addEventListener('scroll',update,{...options,passive:true});
   track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(Math.round(track.scrollLeft/step())+(event.key==='ArrowRight'?1:-1));}},options);
   this.resize=new ResizeObserver(rebuild);this.resize.observe(track);rebuild();
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
 });
}
